module.exports = __webpack_public_path__ + "img/xs_pic.f10f3bc7.png";